import { motion } from "framer-motion";
import { CHANNELS } from "@/data/channels";
import ChannelCard from "@/components/ChannelCard";
import { ShieldCheck } from "lucide-react";

export default function Guides() {
  return (
    <section id="guides" data-testid="guides" className="bg-fog">
      <div className="mx-auto max-w-6xl px-5 py-20 sm:px-8 md:py-28">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-pink">
            The four channels
          </div>
          <h2 className="mt-3 text-[28px] font-bold leading-[1.1] tracking-[-0.025em] text-navy md:text-[38px]">
            Grant access in just a few minutes.
          </h2>
          <p className="mt-3 text-base text-navy/70 md:text-lg">
            Copy what's highlighted, follow the steps, and you're done. Need all four? Work
            top to bottom — it's quicker than it looks.
          </p>
        </motion.div>

        <div className="mt-8 flex flex-wrap gap-3" data-testid="channel-jump-nav">
          {CHANNELS.map((c) => (
            <a
              key={c.id}
              href={`#channel-${c.id}`}
              data-testid={`jump-${c.id}`}
              className="rounded-full border-2 border-navy/15 bg-white px-5 py-2.5 text-sm font-bold text-navy transition-colors duration-200 hover:border-navy hover:bg-navy hover:text-white"
            >
              {c.name}
              {c.optional ? " · optional" : ""}
            </a>
          ))}
        </div>

        <div className="mx-auto mt-12 flex max-w-3xl flex-col gap-6">
          {CHANNELS.map((channel, i) => (
            <ChannelCard key={channel.id} channel={channel} index={i} />
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mx-auto mt-10 flex max-w-2xl items-start justify-center gap-2 text-center text-sm leading-relaxed text-navy/60"
        >
          <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-green" />
          <span>
            We never ask for your passwords. Every access above is official delegation you can
            revoke with one click, anytime.
          </span>
        </motion.p>
      </div>
    </section>
  );
}
